module.exports = __webpack_public_path__ + "img/maisonette-12.ca875bf8.webp";